var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetmarketicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.935,
    height: 43.701,
    viewBox: "0 0 54.935 43.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(-484.294 -494.667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 5.189,
    cy: 5.189,
    r: 5.189,
    transform: "translate(506.848 527.989)",
    fill: "#08a594"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5.19,
    cy: 5.19,
    r: 5.19,
    transform: "translate(528.849 521.089)",
    fill: "#08a594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M532.994,494.806l-22.908,7.01-.021,0-10.38,2.955a6.869,6.869,0,0,1-5.341-.659l-6.753-3.885a2.189,2.189,0,0,0-3.012.857,2.281,2.281,0,0,0,.841,3.072l6.754,3.884a11.328,11.328,0,0,0,3.248,1.252c.006.037,0,.072.011.109l3.283,16.385a3.194,3.194,0,0,0,4.365,2.364l34.046-14.409a3.278,3.278,0,0,0,1.935-3.528l-1.984-12.792A3.2,3.2,0,0,0,532.994,494.806Zm-1.244,9.175.528,3.41a1.8,1.8,0,0,1-1.06,1.933l-25.142,10.641a1.75,1.75,0,0,1-2.391-1.295l-1.231-6.144a1.794,1.794,0,0,1,1.215-2.073l25.844-7.908A1.755,1.755,0,0,1,531.75,503.98Z",
    transform: "translate(0)",
    fill: "#08a594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M510.03,520.473",
    transform: "translate(-0.377 -0.352)",
    fill: "#08a594",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M527.125,513.38",
    transform: "translate(-0.627 -0.255)",
    fill: "#08a594",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M524.628,498.764",
    transform: "translate(-0.59 -0.299)",
    fill: "#08a594",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetmarketicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/betmarket.icon.8482411ea2e3a89bdc0eeabd89cafedc.svg";
export { ForwardRef as ReactComponent };